import { actions as snactions } from '../../snackbar'
import service from '../parent-api-service'
import types from '../types'
import fetchParents from './fetch'

const snack = (dispatch, msg) => dispatch(snactions.addSnackbarItem(msg))

const inviteParent = (parentId) => (dispatch) => {
  dispatch({
    type: types.INVITE_PARENTS_START,
  })
  return service
    .inviteParent(parentId)
    .then(() => {
      dispatch({ type: types.INVITE_PARENTS_SUCCESS })
      snack(dispatch, 'Invitation was sent')
      dispatch(fetchParents())
    })
    .catch(() => {
      dispatch({ type: types.INVITE_PARENTS_FAILURE })
      snack(dispatch, 'An error occured when inviting a parent')
    })
}

export default inviteParent
